import React from "react";

const CopyWorkoutModal = ({
  isVisible,
  onClose,
  programs,
  pvalue,
  onProgramChange,
  copyDetail,
  selectedworks,
  workIds,
  detail,
  onCopyWorkout,
  onToggleWorkout,
  onRemoveWork
}) => {
  if (!isVisible) return null;

  return (
    <div className="excercise-modal">
      <div className="child-modal">
        <div className="add-excersie">
          <span>Select program to copy workouts </span>
          <i className="fa fa-times" onClick={onClose}></i>
        </div>
        
        <div className="programs-copy">
          <select
            name=""
            value={pvalue}
            onChange={onProgramChange}
            className="form-control"
            id=""
          >
            <option value="">Select program</option>
            {programs?.map((prog) => (
              <option key={prog?.id} value={prog?.id}>{prog?.name}</option>
            ))}
          </select>
        </div>

        <div className="copied-detail">
          {workIds?.length > 0 && (
            <ul className="copyyul">
              <li>Copy</li>
              {selectedworks?.map((work) => (
                <li key={work?.id}>
                  <span className="name">{work?.name},</span>
                </li>
              ))}
              <li>to {detail?.name} Program</li>
            </ul>
          )}
          {workIds?.length > 0 && (
            <div className="copy-header">
              <button className="button" onClick={onCopyWorkout}>
                Copy selected workouts
              </button>
            </div>
          )}
        </div>
        
        {copyDetail?.length > 0 && <p>Choose workouts below</p>}
        
        {selectedworks?.length > 0 && (
          <ul className="selected-works">
            {selectedworks?.map((work) => (
              <li key={work?.id}>
                <div className="work">
                  <span className="name">{work?.name}</span>
                  <i
                    className="fa fa-times"
                    onClick={() => onRemoveWork(work)}
                  ></i>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      
      {copyDetail?.length > 0 && (
        <div className="wrapp-user">
          <ul>
            {copyDetail?.map((copy) => (
              <li
                key={copy?.id}
                className={selectedworks.includes(copy) ? "selected" : ""}
                onClick={() => onToggleWorkout(copy)}
              >
                <p className="name">{copy?.name}</p>
                <p className="value">
                  {copy?.exercises?.length} exercises (Repeats every {copy?.day})
                </p>
                <p className="value">{copy?.desc?.substring(0, 100)}</p>
                <div className="buttons">
                  {copy?.workout_type && (
                    <button>{copy?.workout_type}</button>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CopyWorkoutModal;
